import { version } from 'process';
import semver from 'semver';

export const supportNapi3 = semver.satisfies(version, '>=10.0.0');

export const supportNapi4 = semver.satisfies(version, '>=10.16.0 || >=11.8.0 || >=12.0.0');

// See: https://github.com/nodejs/node/issues/37236
export const supportNapiClassRef = semver.satisfies(version, '>=14.17.0');
